import {
    ProductTileMapper,
    ProductTileModel,
} from "@api/mappers/products.mapper";

import { ProductBundleApiModel } from "../../@types/service/product/api/productBundle.api.model";

export type ProductBundleModel = {
    bundleProducts: Array<ProductTileModel>;
};

export const ProductBundleMapper = (
    productBundleApiModel: ProductBundleApiModel,
): ProductBundleModel => ({
    ...productBundleApiModel,
    bundleProducts: productBundleApiModel.products.map(ProductTileMapper),
});
